var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto text-center"},[_c('v-row',[_c('v-col',[_c('v-sheet',{attrs:{"height":"650","width":"1200"}},[_c('v-calendar',{ref:"calendar",attrs:{"now":_vm.today,"value":_vm.today,"events":_vm.events,"color":"primary","type":"week"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }